import request from 'services/request';

const AGREEMENTS_API = '/Agreements/Api/v1/SellIn/';
const AGREEMENTS_REPORT = `${AGREEMENTS_API}Reports/`;

export async function getReport({ sourceId, params, cancelToken }) {
  // ${sourceId}
  return request(`${AGREEMENTS_REPORT}Report?`, {
    method: 'GET',
    responseType: 'blob',
    params,
    cancelToken,
    handlerEnabled: false,
  });
}

export async function getCatalogReportByName({ reportName = '', params, cancelToken }) {
  return request(`${AGREEMENTS_REPORT}Catalog/${reportName}`, {
    method: 'GET',
    params,
    cancelToken,
  });
}
export async function getGenerateFile({ data, cancelToken }) {
  // const customBaseURL = `${process.env.REACT_APP_API_REPORTS}Reports/Api/v1/Agreements`;

  return request(`${AGREEMENTS_API}Reports/generate`, {
    method: 'POST',
    cancelToken,
    data: data,
  });
}

export async function getClientsApprovedList({ clientId, cancelToken }) {
  return request(`${AGREEMENTS_REPORT}Catalog/Clients/${clientId}`, {
    method: 'GET',
    cancelToken,
  });
}

export function getMassiveUpload({ sourceId, params, cancelToken }) {
  // ${sourceId}
  return request(`${AGREEMENTS_REPORT}ReportMassive`, {
    method: 'GET',
    responseType: 'blob',
    params,
    cancelToken,
    handlerEnabled: false,
  });
}
